import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=55d8572a&scoped=true&"
import script from "./InputNumber.vue?vue&type=script&lang=ts&"
export * from "./InputNumber.vue?vue&type=script&lang=ts&"
import style0 from "./InputNumber.vue?vue&type=style&index=0&id=55d8572a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8572a",
  null
  
)

export default component.exports